module.exports = __webpack_public_path__ + "7865012ebe5cf5ab6b7cb1dccc997eef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/goggles-s.png
// module id = 2351
// module chunks = 0